var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dash-card",class:_vm.classes},[(_vm.title)?_c('div',{staticClass:"dash-card__header"},[_c('span',{staticClass:"dash-card__title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"dash-card__divider"})]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }